module.exports = __webpack_public_path__ + "static/media/Upper-page.9f87893e.svg";